import React, { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from "yup";
import { message, Button } from "antd";
import Load from "../Load/Load"
import { addClinic } from '../../Web Apis/webApis';

const AddClinic = ({ showModal, setShowModal, action, setAction }) => {
    const [open, setOpen] = useState(showModal)
    const [loading, setLoading] = useState(false)

    const closeModal = () => {
        setOpen(false)
        setShowModal(false)
    }

    const formik = useFormik({
        initialValues: {
            clinicName: ""
        },
        validationSchema: Yup.object({
            clinicName: Yup.string()
            .required("Clinic name is mandatory")
            .max(30, "Clinic name can not be more than 30 characters")
            .min(3, "Clinic name should have atleast 3 characters")
            .trim("Clinic name should not have spaces only")
        }),
        onSubmit: async (values, { resetForm, setSubmitting }) => {
            try {
                setLoading(true)
                const ClinicData = {
                    clinicName: values.clinicName
                }
                const response = await addClinic(ClinicData)
                if (response?.data?.success) {
                                    message.success(response?.data?.message)
                                    resetForm()
                                    setOpen(false)
                                    setShowModal(false)
                                    setAction(!action)
                                }
                
            } catch (error) {
                console.log("Error while creating clinic", error.message)
                message.error(error?.response?.data?.message || "Error while creating admin profile")
            } finally {
                setSubmitting(false)
                setLoading(false)
            }
        }
    })


    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-lg shadow-lg w-[400px] h-[320px] overflow-y-auto scrollbar-hidden">
                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-teal-950 to-teal-500 py-2 text-white">
                    Add Clinic
                </h3>
                <form onSubmit={formik.handleSubmit} className='p-8'>

                    <div className="w-full">
                        <label className="block mb-1 mt-2">Clinic Name</label>
                        <input
                            type="text"
                            name="clinicName"
                            className="border border-gray-800 p-2 w-full"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.clinicName}
                            placeholder='Enter your clinic name'
                        />
                        {formik.touched.clinicName && formik.errors.clinicName && (
                            <p className="text-red-600">{formik.errors.clinicName}</p>
                        )}
                    </div>


                    <div className="flex justify-center gap-6 mt-12">
                        <button
                            onClick={closeModal}
                            className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
                        >
                            {formik.isSubmitting ? "Adding..." : "Add"}
                        </button>
                    </div>
                </form>
                        {loading && <Load/>}
            </div>
        </div>
    )
}

export default AddClinic